import React from "react";
import Toolbar, { Item } from "devextreme-react/toolbar";
import Button from "devextreme-react/button";
import UserPanel from "../user-panel/user-panel";
import "./header.scss";
import { Template } from "devextreme-react/core/template";
import { criarPrefeituraDs } from "../../DataSources";
import UserInfo from "../../UserInfo";
import { navigation } from "../../app-navigation";
import Menu from "devextreme-react/menu";
import SeletorPrefeitura from "../seletor-prefeitura/seletor-prefeitura";
import Logo from "../../images/logotrimap-short.png";
import abrirLink from "../../abrirLink";
import DataSource from "devextreme/data/data_source";

const larguraAdpatavel = 825;

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.menuToggleEnabled = props.menuToggleEnabled;
    this.title = props.title;
    this.toggleMenu = props.toggleMenu;
    this.userMenuItems = props.userMenuItems;

    this.dataSource = new DataSource({
      store: criarPrefeituraDs(),
      remoteOperations: false, // ordena no cliente
      sort: [{ selector: "prefeituraTopo", desc: false }],
    });

    this.irPara = this.irPara.bind(this);
    this.goHome = this.goHome.bind(this);
    this.state = { prefeituraId: UserInfo.getPrefeitura(), seletorAberto: false, adaptavel: window.innerWidth < larguraAdpatavel };
    this.handleResize = this.handleResize.bind(this);
  }

  handleResize() {
    this.setState({ adaptavel: window.innerWidth < larguraAdpatavel });
  }

  irPara(e) {
    e.event.preventDefault();

    abrirLink(this.props.history, e, e.itemData.path);
  }

  goHome() {
    this.props.history.push("/");
  }

  async componentDidMount() {

    window.addEventListener("resize", this.handleResize);

    if (this.state.prefeituraId) {
      let listaPrefeituras = await this.dataSource.load({
        filter: [["id", "=", this.state.prefeituraId]],
      });

      let prefeituraDesejada = listaPrefeituras
        .filter(pref => pref.id == this.state.prefeituraId);

      if (prefeituraDesejada.length > 0 && prefeituraDesejada[0] !== undefined) {
        console.log("carregando prefeitura", prefeituraDesejada);
        this.setState({ logoPath: prefeituraDesejada[0].prefeituraLogo });
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  render() {
    // const relatorioOptions = {
    //   text: 'Relatórios',
    //   icon: 'chart',
    //   items: [
    //     {
    //       text: 'Relatorios',
    //       path: '/relatorios',
    //     },
    //     {
    //       text: 'Display Data C',
    //       path: '/mov2'
    //     },
    //     {
    //       text: 'Juros C',
    //       path: '/mov3'
    //     }
    //   ]
    // }
    return (
      <header className={"header-component"}>
        <Toolbar className={"header-toolbar"}>
          {/* <Item
            visible={this.menuToggleEnabled}
            location={'before'}
            widget={'dxButton'}
            cssClass={'menu-button'}
            options={{
              icon: 'menu',
              stylingMode: 'text',
              onClick: this.toggleMenu
            }}
          /> */}
          {/* <Item
            location={'before'}
            cssClass={'header-title'}
            text={this.title}
            visible={!!this.title}
             /> */}
          <Item location={"before"} cssClass={"header-title"}>
            <img
              src={this.state.logoPath || Logo}
              alt="Logo prefeitura"
              width={this.state.logoPath ? 45 : 125}
              onClick={this.goHome}
            />
          </Item>
          <Item location={"before"} text={this.title} widget="dxMenu">
            <Menu
              dataSource={navigation}
              adaptivityEnabled={this.state.adaptavel}
              width={"auto"}
              onItemClick={this.irPara}
            />
          </Item>
          {/* <Item
            location={'before'}
            text={this.title}
          >
            <Menu dataSource={relatorioOptions} adaptivityEnabled={true} onItemClick={this.irPara} />

          </Item> */}

          <Item
            location={"after"}
            locateInMenu={"auto"}
            menuItemTemplate={"userPanelTemplate"}
          >
            <Button
              className={"user-button authorization"}
              width={"auto"}
              height={"100%"}
              stylingMode={"text"}
            >
              <UserPanel menuItems={this.userMenuItems} menuMode={"context"} />
            </Button>
          </Item>
          {UserInfo.eSuporte() ? (
            <Item location={"after"} locateInMenu={"auto"}>
              <Button
                text="AMBIENTE"
                icon="refresh"
                stylingMode="text"
                onClick={() => this.setState({ seletorAberto: true })}
              />
            </Item>
          ) : null}
          <Template name={"userPanelTemplate"}>
            <UserPanel menuItems={this.userMenuItems} menuMode={"list"} />
          </Template>
        </Toolbar>
        {UserInfo.eSuporte() ? (
          <SeletorPrefeitura
            aberto={this.state.seletorAberto}
            onFechar={() => this.setState({ seletorAberto: false })}
          />
        ) : null}
      </header>
    );
  }
}
